"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TodayLine = exports.SelectionRangeEdge = exports.SelectionRange = exports.PreviewRange = exports.NumberContainer = exports.DayNumber = exports.DayCell = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function getTodayLineColor(_ref) {
  var isPassive = _ref.isPassive,
    isSelected = _ref.isSelected,
    isEdge = _ref.isEdge,
    theme = _ref.theme;
  if (isPassive) {
    return theme.dayPassiveColor;
  }
  if (theme.isClassic) {
    return isSelected ? theme.todaySelectedLineColor : theme.todayLineColor;
  }
  return isSelected && isEdge ? theme.todaySelectedLineColor : theme.todayLineColor;
}
function getDayNumberColor(_ref2) {
  var isDisabled = _ref2.isDisabled,
    isPassive = _ref2.isPassive,
    isSelected = _ref2.isSelected,
    isEdge = _ref2.isEdge,
    theme = _ref2.theme;
  if (isDisabled) {
    return theme.dayDisabledColor;
  }
  if (isPassive) {
    return theme.dayPassiveColor;
  }
  if (theme.isClassic) {
    return isSelected ? theme.daySelectedColor : theme.dayColor;
  }
  if (isSelected) {
    return isEdge ? theme.daySelectedEdgeColor : theme.daySelectedColor;
  }
  return theme.dayColor;
}
function getSelectionRadius(_ref3) {
  var isStartEdge = _ref3.isStartEdge,
    isEndEdge = _ref3.isEndEdge;
  var radius = '';
  if (isStartEdge) {
    radius += "\n      border-top-left-radius: 50%;\n      border-bottom-left-radius: 50%;\n      left: 4px;\n    ";
  }
  if (isEndEdge) {
    radius += "\n      border-top-right-radius: 50%;\n      border-bottom-right-radius: 50%;\n      right: 4px;\n    ";
  }
  return radius;
}
function getPreviewBorderStyle(_ref4) {
  var theme = _ref4.theme,
    isStartEdge = _ref4.isStartEdge,
    isEndEdge = _ref4.isEndEdge;
  var borderStyle = '';
  if (isStartEdge) {
    borderStyle += "\n      border-top-left-radius: 50%;\n      border-bottom-left-radius: 50%;\n      left: ".concat(theme.isClassic ? '2px' : '4px', ";\n    ");
  } else {
    borderStyle += "\n      border-left: none;\n    ";
  }
  if (isEndEdge) {
    borderStyle += "\n      border-top-right-radius: 50%;\n      border-bottom-right-radius: 50%;\n      right: ".concat(theme.isClassic ? '2px' : '4px', ";\n    ");
  } else {
    borderStyle += "\n      border-right: none;\n    ";
  }
  return borderStyle;
}
var DayCell = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n\n  cursor: pointer;\n  outline: none;\n  pointer-events: ", ";\n\n  box-sizing: border-box;\n\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  letter-spacing: ", ";\n\n  color: ", ";\n  background: ", ";\n  width: ", ";\n  height: ", ";\n"])), function (_ref5) {
  var isPassive = _ref5.isPassive,
    isDisabled = _ref5.isDisabled;
  return isPassive || isDisabled ? 'none' : 'auto';
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.isClassic ? theme.dayFontSize : theme.numbersTypography.fontSize;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.isClassic ? theme.lineHeight : theme.numbersTypography.lineHeight;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.isClassic ? undefined : theme.numbersTypography.fontWeight;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.isClassic ? theme.fontFamily : theme.numbersTypography.fontFamily;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.isClassic ? undefined : theme.numbersTypography.letterSpacing;
}, getDayNumberColor, function (_ref11) {
  var theme = _ref11.theme;
  return theme.dayBackground;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.daySize;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.daySize;
});
exports.DayCell = DayCell;
DayCell.propTypes = {
  isSelected: _propTypes["default"].bool,
  isPassive: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool,
  theme: _propTypes["default"].object
};
var baseRangeStyle = (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n\n  top: 4px;\n  right: 0;\n  bottom: 4px;\n  left: 0;\n  display: ", ";\n"])), function (_ref14) {
  var isVisible = _ref14.isVisible;
  return isVisible ? 'block' : 'none';
});
var SelectionRange = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  ", "\n\n  background: ", ";\n"])), baseRangeStyle, getSelectionRadius, function (_ref15) {
  var isDisabled = _ref15.isDisabled,
    theme = _ref15.theme;
  return isDisabled ? theme.daySelectedDisabledBackground : theme.daySelectedBackground;
});
exports.SelectionRange = SelectionRange;
SelectionRange.propTypes = {
  isDisabled: _propTypes["default"].bool,
  isInRange: _propTypes["default"].bool,
  isStartEdge: _propTypes["default"].bool,
  isEndEdge: _propTypes["default"].bool,
  isVisible: _propTypes["default"].bool,
  theme: _propTypes["default"].object
};
var SelectionRangeEdge = _styledComponents["default"].span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  right: 4px;\n  left: 4px;\n\n  border-radius: 50%;\n\n  background: ", ";\n\n  ", "\n"])), baseRangeStyle, function (_ref16) {
  var isDisabled = _ref16.isDisabled,
    theme = _ref16.theme;
  return isDisabled ? theme.daySelectedDisabledBackground : theme.daySelectedEdgeBackground;
}, function (_ref17) {
  var theme = _ref17.theme;
  return !theme.isClassic && (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      ", ":hover && {\n        background: transparent;\n      }\n    "])), DayCell);
});
exports.SelectionRangeEdge = SelectionRangeEdge;
SelectionRangeEdge.propTypes = {
  isDisabled: _propTypes["default"].bool,
  isInRange: _propTypes["default"].bool,
  isStartEdge: _propTypes["default"].bool,
  isEndEdge: _propTypes["default"].bool,
  isVisible: _propTypes["default"].bool,
  theme: _propTypes["default"].object
};
var PreviewRange = _styledComponents["default"].span(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  background: ", ";\n  border-width: ", ";\n  border-style: ", ";\n  border-color: ", ";\n  display: ", ";\n  top: ", ";\n  right: 0;\n  bottom: ", ";\n  left: 0;\n  ", ";\n"])), function (_ref18) {
  var theme = _ref18.theme;
  return theme.dayPreviewBackground;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.dayPreviewBorderWidth;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.dayPreviewBorderStyle;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.dayPreviewBorderColor;
}, function (_ref22) {
  var isVisible = _ref22.isVisible;
  return isVisible ? 'block' : 'none';
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.isClassic ? '2px' : '4px';
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.isClassic ? '2px' : '4px';
}, getPreviewBorderStyle);
exports.PreviewRange = PreviewRange;
PreviewRange.propTypes = {
  isInRange: _propTypes["default"].bool,
  isStartEdge: _propTypes["default"].bool,
  isEndEdge: _propTypes["default"].bool,
  isVisible: _propTypes["default"].bool,
  theme: _propTypes["default"].object
};
var DayNumber = _styledComponents["default"].span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: relative;\n  margin-top: ", ";\n\n  ", "\n"])), function (_ref25) {
  var theme = _ref25.theme,
    isToday = _ref25.isToday;
  return isToday && theme.todayLineHeight;
}, function (_ref26) {
  var theme = _ref26.theme,
    isToday = _ref26.isToday;
  return !theme.isClassic && isToday && (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      font-size: ", ";\n      line-height: ", ";\n      font-weight: ", ";\n      font-family: ", ";\n      letter-spacing: ", ";\n    "])), theme.todayTypography.fontSize, theme.todayTypography.lineHeight, theme.todayTypography.fontWeight, theme.todayTypography.fontFamily, theme.todayTypography.letterSpacing);
});
exports.DayNumber = DayNumber;
var TodayLine = _styledComponents["default"].span(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: relative;\n\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n  background: ", ";\n\n  ", "\n"])), function (_ref27) {
  var theme = _ref27.theme;
  return theme.todayLineWidth;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.todayLineHeight;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.lineBorderRadius;
}, getTodayLineColor, function (_ref30) {
  var theme = _ref30.theme;
  return !theme.isClassic && (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n      ", ":hover && {\n        background: ", ";\n      }\n    "])), DayCell, theme.todayLineColor);
});
exports.TodayLine = TodayLine;
TodayLine.propTypes = {
  isSelected: _propTypes["default"].bool,
  isPassive: _propTypes["default"].bool,
  isEdge: _propTypes["default"].bool
};
var NumberContainer = _styledComponents["default"].div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  bottom: ", ";\n  right: ", ";\n  display: inline-flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  ", ":hover && {\n    color: ", ";\n\n    background: ", ";\n    border-width: ", ";\n    border-style: ", ";\n    border-color: ", ";\n    border-radius: 50%;\n  }\n"])), function (_ref31) {
  var theme = _ref31.theme;
  return theme.isClassic ? '2px' : '4px';
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.isClassic ? '2px' : '4px';
}, function (_ref33) {
  var theme = _ref33.theme;
  return theme.isClassic ? '2px' : '4px';
}, function (_ref34) {
  var theme = _ref34.theme;
  return theme.isClassic ? '2px' : '4px';
}, DayCell, function (_ref35) {
  var theme = _ref35.theme;
  return theme.isClassic ? undefined : theme.dayColor;
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.dayPreviewBackground;
}, function (_ref37) {
  var theme = _ref37.theme;
  return theme.dayPreviewBorderWidth;
}, function (_ref38) {
  var theme = _ref38.theme;
  return theme.dayPreviewBorderStyle;
}, function (_ref39) {
  var theme = _ref39.theme;
  return theme.dayPreviewBorderColor;
});
exports.NumberContainer = NumberContainer;